module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hant_6-5f8a5a9af6f059a81cc416c16176103d.jpg";